module.exports = __webpack_public_path__ + "static/img/invest-consume4.f64e6b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume4.jpg
// module id = 3BCw
// module chunks = 0